
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"600","height":"610.667","viewBox":"0 0 450 458"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M224.1 21.4c-4.1 2.3-5 5.3-5.1 16.7v10.6h19V38.4c0-11.5-1-14.8-5.1-17-3.4-1.7-5.7-1.7-8.8 0zM222.5 68c-2.7 1.1-5.9 4.8-7.4 8.5-.7 2-1.1 7.5-.9 15l.3 12h28v-13c0-14.7-.9-17.5-6.4-21.2-3.5-2.4-9.7-3-13.6-1.3zM212.5 113.7c-29.9 1.4-56.2 6-67.5 11.6l-4.5 2.2-.3 12.7c-.3 14.7-.7 14.2 8.9 10.9 6.8-2.3 17.8-4.5 33.9-6.8 18-2.5 74.2-2.5 91.5 0 16.8 2.5 26.9 4.6 34.8 7.3 5.1 1.7 6.9 1.9 7.3 1 .3-.7.3-6.6.2-13.2l-.3-11.9-4.5-2.2c-11-5.4-34.1-9.6-62.4-11.3-16.9-.9-23.2-1-37.1-.3zM193 161.6c-15.5 1.6-23.1 2.9-34 5.6-9 2.2-17 5.5-17 6.9 0 2.9 18.5 8 42 11.6 17 2.5 72.6 2.5 89.5-.1 16.3-2.4 23.7-4 32.4-7 11.9-4 11.4-5.5-3.4-10-24.8-7.7-74.3-10.8-109.5-7zM44.3 274c-4.4 2.6-6.6 6.4-6.7 11.3-.1 5.4 2 9.5 6.3 12.4l3.4 2.3h362.2l3.7-2.5c5-3.4 7.5-9.8 5.8-15.2-.7-2.1-2-4.6-2.9-5.7-4.2-4.8 5.3-4.6-187.8-4.6-177.4 0-180.9 0-184 2zM104.7 318.8c-2.4.5-3 4-2.5 13.2.5 8.6 2.3 12.5 6.4 14 1.6.6 47.8 1 120 1 126.5 0 121.6.2 124.4-4.9.5-1.1 1-6.7 1-12.5V319h-10.2c-5.7 0-61.4-.1-123.9-.3-62.4-.1-114.3-.1-115.2.1zM214.7 365.6c-.4.4-.7 13-.7 28.1V421h-76.8l-3.1 2.6c-2.6 2.1-3.1 3.3-3.1 6.9 0 3.6.5 4.8 3.1 6.9l3.1 2.6h183l2.9-2.9c4-4.1 4-9.1 0-13.2l-2.9-2.9H243l-.2-27.8-.3-27.7-13.6-.3c-7.4-.1-13.8.1-14.2.4z"}})])
          )
        }
      }
    